import { hrefFactoryForLegacyModules } from '../backstage-content';
import { BACKSTAGE_CONTENT_PERMISSION } from '../taboola-common-frontend-modules/authentication';

const MODULE_NAME = 'contact-support';
const externalPath = 'customer-services/contact/new';

const hrefGetter = hrefFactoryForLegacyModules(MODULE_NAME, externalPath);
const permissions = BACKSTAGE_CONTENT_PERMISSION;

export { MODULE_NAME, hrefGetter, permissions, externalPath };
